export default __webpack_public_path__ + "d5d73c884fa21fc85088663cda583ce7.svg";